import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import ActionModal from "./ActionModal";
import "./LeadsDataTable.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Hexapi from "../usefulcomps/HexAPI/Hexapi";
import PaginationBar from "./PaginationBar";

export default function LeadsDataTable(props) {
  const [headers, setHeaders] = useState([]);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [Selectedrowindex, setSelectedRowIndex] = useState(-1);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const [totalCount, setTotalCount] = useState(0);
  const [SelectedenquiryID, setSelectedenquiryID] = useState(0);
  const [SelectedCustomerName, setSelectedCustomerName] = useState("");
  const [showActionModal, setshowActionModal] = useState(false);
  const [AgentID, setAgentID] = useState(0);

  useEffect(() => {
    GetUserDetails();
    setCurrentPage(1);
  }, [props.leadTypeID]);

  useEffect(() => {
    GetUserDetails();
  }, [currentPage, rowsPerPage]);

  const GetUserDetails = async () => {
    let obj = {
      query: `[dbo].[CRM_Proc_User_GetDetails] @SessionID='{0}'`,
      queryArr: [`${localStorage.getItem("SessionID")}`],
    };
    try {
      const resp = await Hexapi(obj);
      console.log(resp);
      const result = resp[""]?.[0];
      setAgentID(result?.agentid);
      const agentID = result?.agentid;
      fetchLeads(agentID, currentPage, props.leadTypeID, rowsPerPage);
    } catch {}
  };

  const fetchLeads = (agentID, pageNum, leadtype, limit) => {
    setLoading(true);

    let obj = {
      query: `[dbo].[CRM_Proc_Leads_GetList] @AgentID = '{0}',@PageNo='{1}', @LeadType='{2}', @limit='{3}'`,
      queryArr: [`${agentID}`, `${pageNum}`, `${leadtype}`, `${limit}`],
    };

    Hexapi(obj)
      .then((resp) => {
        console.log("FetchDetails:", resp);
        const data = resp[""] || [];
        const totalCount = resp["totalcount"][0]["totalcount"] || [];
        setHeaders(Object.keys(resp[""][0]));
        setRows(data);
        setTotalCount(totalCount);
      })
      .catch((err) => {
        console.error("Error fetching leads:", err);
        setRows([]);
        setTotalCount(0);
      })
      .finally(() => setLoading(false));
  };

  const handleRowClick = (globalIndex) => {
    console.log(globalIndex);
    setSelectedenquiryID(globalIndex["e.id"]);
    setSelectedCustomerName(globalIndex["name"]);
    setshowActionModal(true);
  };

  return (
    <div>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            padding: "20px",
            minHeight: "85vh",
          }}
        >
          <div className="spinner-border text-dark" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <>
          <div className="outertable">
            <Table responsive className="table table-striped table-container">
              <thead scope="row" style={{ whiteSpace: "nowrap" }}>
                <tr
                  style={{
                    background: "#337ab7",
                    color: "white",
                    position: "sticky",
                    top: "0px",
                  }}
                >
                  {headers.map((s, index) => (
                    <th
                      style={{
                        background: "#000",
                        color: "white",
                        position: "sticky",
                        top: 0,
                        zIndex: 2,
                        whiteSpace: "nowrap",
                      }}
                      key={index}
                    >
                      {s.toUpperCase()}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody style={{ whiteSpace: "nowrap", cursor: "pointer" }}>
                {rows.length === 0 ? (
                  <tr>
                    <td colSpan={headers.length} className="text-center py-4">
                      No Records!
                    </td>
                  </tr>
                ) : (
                  rows.map((row, localIndex) => {
                    const globalIndex = indexOfFirstRow + localIndex;
                    const isHighlighted = Selectedrowindex === globalIndex;

                    return (
                      <tr
                        key={globalIndex}
                        className={isHighlighted ? "highlighted" : ""}
                      >
                        {headers.map((key, colIndex) => {
                          const cellValue = row[key] ?? "";

                          if (key === "status") {
                            return (
                              <td key={colIndex}>
                                <img
                                  style={{ width: "25px", height: "25px" }}
                                  src={`https://via.placeholder.com/25?text=${cellValue}`}
                                  onClick={() => handleRowClick(row)}
                                />
                              </td>
                            );
                          }

                          return (
                            <td
                              key={colIndex}
                              onClick={() => handleRowClick(row)}
                            >
                              {cellValue}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
          </div>
        </>
      )}
      <PaginationBar
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[5, 10, 25, 50]}
        count={totalCount}
        onPageChange={(page) => {
          console.log(page);
          setCurrentPage(page + 1);
        }}
        onRowsChange={(rows) => {
          setRowsPerPage(rows);
          setCurrentPage(1);
        }}
        CurrentPage={currentPage - 1}
      />

      {/* FIX: Always render ActionModal and control visibility via show prop.
          The previous conditional render { showActionModal ? <ActionModal/> : null }
          was mounting/unmounting the component on every open/close, which reset
          all internal state including activeChildModal back to null. */}
      <ActionModal
        show={showActionModal}
        enquiryID={SelectedenquiryID}
        customerName={SelectedCustomerName}
        onHide={() => setshowActionModal(false)}
        leadTypeID={props.leadTypeID}
        AgentID={AgentID}
      />
    </div>
  );
}
